import { render } from "./MyChats.vue?vue&type=template&id=a139de52&scoped=true"
import script from "./MyChats.vue?vue&type=script&lang=js"
export * from "./MyChats.vue?vue&type=script&lang=js"

import "./MyChats.vue?vue&type=style&index=0&id=a139de52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a139de52"]])

export default __exports__